import 'css-chunk:src/index.scss';export default {};